import requests from "./httpService";

const OldProfileService = {

    getsingleData : async (id) =>{
   
        return requests.get(`/oldprofile/user/${id}`);
    },
    getAllUserSearch : async () =>{
   
        return requests.get(`/oldprofile/pro`);
    },
    getAllUser: async (page, search, status, verified, district, policeStation) => {
        let queryParams = `page=${page}`;
        if (search) queryParams += `&search=${encodeURIComponent(search)}`;
        if (status) queryParams += `&status=${encodeURIComponent(status)}`;
        if (verified) queryParams += `&verified=${encodeURIComponent(verified)}`;
        if (district) queryParams += `&district=${encodeURIComponent(district)}`;
        if (policeStation) queryParams += `&policeStation=${encodeURIComponent(policeStation)}`;
        return requests.get(`/oldprofile?${queryParams}`);
    },
    getAllReport: async () => {
        return requests.get(`/oldprofile/download-excel`);
    },
      getcircleThanaProfiles : async () =>{
   
        return requests.get(`/admin/thanaName`);
    },
    getcircleThanaProfilesOld: async (page, search, status, verified, district, policeStation) => {
        let queryParams = `page=${page || 1}`;
        if (search) queryParams += `&search=${encodeURIComponent(search)}`;
        if (status) queryParams += `&status=${encodeURIComponent(status)}`;
        if (verified) queryParams += `&verified=${encodeURIComponent(verified)}`;
        if (district) queryParams += `&district=${encodeURIComponent(district)}`;
        if (policeStation) queryParams += `&policeStation=${encodeURIComponent(policeStation)}`;
        return requests.get(`/admin/thanaNameOld?${queryParams}`);
    },
    updateUser : async (id,body) =>{
        return requests.patch(`/oldprofile/${id}`,body);
    },
    updateUserStatus : async (id,body) =>{
        return requests.patch(`/oldprofile/${id}/status`,body);
    },
    getMyProfile : async () =>{
        return requests.get(`/userapp/profile`);
    },
    updateMe : async (body) =>{
        return requests.patch(`/userapp/updateMe`,body);
    },
    createAdmin : async (body) =>{
        // console.log(body)
        return requests.post(`/userapp/`,body);
    },
    updatePassword : async (body) =>{
        return requests.patch(`/userapp/change-password`,body);
    },
    dashboard : async () =>{
        return requests.get(`/userapp/dashboard`);
    },
    getAllAdmin : async () =>{
        return requests.get(`/userapp`);
    },
    getAllThanaAdmin : async () =>{
        return requests.get(`/userapp/get`);
    },
    getState : async () =>{
        return requests.get(`/state`);
    },
    getDistrictByState: async (id,body) =>{
        return requests.get(`/state/${id}`,body);
    },
    getThanaByDistrict: async (id,body) =>{
        return requests.get(`/state/districts/${id}`,body);
    },
    getCircleByDistrict: async (id,body) =>{
        return requests.get(`/state/circle-names/${id}`,body);
    },
    updateAdmin: async (id,body) =>{
        return requests.patch(`/userapp/${id}`,body);
    },
    deleteAdmin: async (id,body) =>{
        return requests.delete(`/userapp/${id}`,body);
    },
    login: async (body) =>{
        return requests.post(`/userapp/login`,body);
    },
   
    

   


}

export default OldProfileService;


